import React, { FunctionComponent } from 'react';
import { authSelectors } from '../../../../app/auth/auth.selectors';
import { meetingsSimplePageSelectors } from '../../../../app/page/page-storage/meetings-simple/meetings-simple.selectors';
import { meetingSimpleSelectors } from '../../../../app/resource/meeting-simple/meeting-simple.selectors';
import { IMeetingSimple } from '../../../../app/resource/meeting-simple/meeting-simple.types';
import { useSelect, useSelectWithParams } from '../../../../utils/selector.utils';
import { CreateMeetingButton } from '../../common/CreateMeetingButton';
import { MeetingRow } from './MeetingRow';
import { IMeetingTableProps } from './types';
import { sortBy } from 'lodash';

export const MeetingTable: FunctionComponent<IMeetingTableProps> = ({ type, sortType }) => {
  const isAdmin = useSelect(authSelectors.selectUserIsAdmin);
  const addLabel = `Add a New ${type === 'account' ? 'Account' : 'Meeting'}`;

  const meetingIds = useSelect(
    type === 'account' ? meetingsSimplePageSelectors.selectAccounts : meetingsSimplePageSelectors.selectTeams,
  );
  const meetings = useSelectWithParams(meetingSimpleSelectors.selectResourcesById, meetingIds) as IMeetingSimple[];

  const meetingsSorted = sortType ? sortBy(meetings, ['title']) : sortBy(meetings, ['title']).reverse();
  return (
    <>
      <div className="accounts-list panel-body pt-0">
        <div className="border-radius-1 lightGray-bg p-2">
          <div className="table-container" role="table" aria-label="Destinations">
            <div className="flex-table header" role="rowgroup">
              <div className="flex-row first" role="columnheader">
                {type === 'account' ? 'Account Name' : 'Meeting Name'}
              </div>
              <div className="flex-row" role="columnheader">
                Members
              </div>
              <div className="flex-row" role="columnheader">
                Next Meeting
              </div>
              <div className="flex-row" role="columnheader"></div>
            </div>
            {meetingsSorted && meetingsSorted.map((meeting) => <MeetingRow key={meeting.id} meetingId={meeting.id} />)}
            {isAdmin && (
              <CreateMeetingButton
                label={addLabel}
                className="link panel text-center flex aic jcc theme-color button_popup"
                showIcon={false}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};
